export default "__VITE_ASSET__C4zcDxk8__"